import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PeopleProfileSnapshotComponent } from './people-profile-snapshot.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { TooltipEllipsifyModule } from 'src/app/directives/tooltip-ellipsify/tooltip-ellipsify.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ModalModule } from 'ngx-bootstrap/modal';
import { PeopleProfileEditDetailsModalModule } from '../people-profile-edit-details-modal/people-profile-edit-details-modal/people-profile-edit-details-modal.module';
import { PeopleProfileShowDetailsModalModule } from '../people-profile-show-details-modal/people-profile-show-details-modal/people-profile-show-details-modal.module';
import { i18nPipeModule } from 'src/app/pipes/i18n-convertor-pipe/i18n-convertor.module';
import {ButtonModule} from '@xref/xref-lib';

@NgModule({
  declarations: [PeopleProfileSnapshotComponent],
  imports: [
    CommonModule,
    // BrowserAnimationsModule,
    // BsDropdownModule.forRoot(),
    TooltipEllipsifyModule,
    TooltipModule.forRoot(),
    ModalModule,
    PeopleProfileEditDetailsModalModule,
    PeopleProfileShowDetailsModalModule,
    i18nPipeModule,
    ButtonModule
  ],
  exports: [
    PeopleProfileSnapshotComponent
  ]
})
export class PeopleProfileSnapshotModule { }
